module.exports = __webpack_public_path__ + "img/glassquality_4.79678fd8.png";